import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"vote-negative-filled-alternate-clip_1\"><path d=\"M15.778 4.464 12.243 8l3.535 3.537-4.242 4.242L8 12.243l-3.536 3.535-4.242-4.242L3.757 8 .222 4.464 4.464.222 8 3.757 11.536.222z\" clip-rule=\"evenodd\"></path></clipPath><clipPath id=\"vote-negative-filled-alternate-clip_2\"><path d=\"M0 16h16V0H0Z\"></path></clipPath></defs><g clip-path=\"url(#vote-negative-filled-alternate-clip_1)\"><g clip-path=\"url(#vote-negative-filled-alternate-clip_2)\"><path fill=\"#298439\" d=\"M8-10.385 26.385 8 8 26.385-10.385 8Z\"></path></g></g>", 2)
  ]))]))
}
export default { render: render }